export const COMMON_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];

export const STUDIO_IMAGE_EXTENSIONS = [...COMMON_IMAGE_EXTENSIONS, 'gif'];

export const STUDIO_LOGO_EXTENSIONS = [...STUDIO_IMAGE_EXTENSIONS, 'svg'];

export const UPLOADS_IMAGE_EXTENSIONS = [...COMMON_IMAGE_EXTENSIONS, 'jfif', 'heic', 'heif', 'gif'];
